// ---------------------------------------------------------------------------
// Primitivos de CONTEÚDO de modal do submódulo (refatoração visual 2026-09-10,
// UI_SPEC §Modal). O shell continua sendo components/Modal/Modal.js (decisão
// D6 — intocado); aqui mora só a anatomia do corpo:
//
//   · ModalIntro  — a primeira coisa do corpo: faixa curta que diz o EFEITO da
//     operação. $tone: 'info' (azul claro) | 'neutral' | 'danger' (destrutiva).
//   · FooterNote  — nota/contagem à ESQUERDA do footer (o Footer do Modal
//     alinha à direita; o margin-right:auto empurra a nota para a ponta).
//   · FlagRow     — <tr> marcável da grade de itens: $flag 'invalid' (fora da
//     regra que o servidor recusaria) | 'short' (linha em falta, âmbar) |
//     'locked' (item travado pelo estado — ex.: com expedição, na edição).
//     O `td` leva `background` próprio para vencer a zebra do DataTable.
// ---------------------------------------------------------------------------
import styled from 'styled-components';

export const ModalIntro = styled.p`
   margin: 0 0 14px;
   padding: 10px 12px;
   border-radius: 8px;
   font-size: 12.5px;
   line-height: 1.55;
   background: ${({ $tone }) => {
      if ($tone === 'danger') return 'rgba(220, 38, 38, 0.06)';
      if ($tone === 'neutral') return '#f7f7f8';
      return '#f2f7fd';
   }};
   border: 1px solid
      ${({ $tone }) => {
         if ($tone === 'danger') return 'rgba(220, 38, 38, 0.22)';
         if ($tone === 'neutral') return 'rgba(0, 0, 0, 0.07)';
         return 'rgba(64, 152, 239, 0.22)';
      }};
   color: ${({ $tone }) => {
      if ($tone === 'danger') return '#8e1b1b';
      return 'rgba(0, 0, 0, 0.72)';
   }};
`;

export const FooterNote = styled.span`
   margin-right: auto;
   align-self: center;
   font-size: 12px;
   line-height: 1.45;
   color: ${({ $warn }) => ($warn ? '#8a5a00' : 'rgba(0, 0, 0, 0.55)')};
   font-weight: ${({ $warn }) => ($warn ? 700 : 400)};
`;

export const FlagRow = styled.tr.attrs(({ $flag }) =>
   $flag ? { 'data-flagged': '' } : {}
)`
   td {
      background: ${({ $flag }) => {
         if ($flag === 'invalid') return 'rgba(220, 38, 38, 0.05)';
         if ($flag === 'short') return '#fffaf2';
         if ($flag === 'locked') return '#f6f7f9';
         return 'transparent';
      }};
   }
`;
